module.exports = __webpack_public_path__ + "img/phone.2821cac0.svg";